import { render } from "./SidebarFieldset.vue?vue&type=template&id=4e89bd48"
import script from "./SidebarFieldset.vue?vue&type=script&lang=js"
export * from "./SidebarFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__